<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("print") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main">
          <table-with-filter
            fixed-header
            :height="$vuetify.breakpoint.height - 210"
            @update:sort="getContractItemsBySort"
            :options.sync="configuration.options"
            :headers="headers"
            handler-value="contractNumber"
            :items="items"
            child-key="items"
            :page="configuration.pagination.page"
          >
            <template #filter.contractNumber>
              <div class="pa-1">
                <custom-input-text
                  v-model="ourProductFilter.contractCode"
                  @input="onChangeHandler"
                  clearable
                  class="user_input no-margin"
                  name="select_on_block"
                ></custom-input-text>
              </div>
            </template>

            <template #filter.productName>
              <div class="pa-1">
                <vue-select
                  :get-item-promise="
                    ({ text, page }) =>
                      $store.dispatch('getProducts', {
                        name: text,
                        page,
                        limit: 15,
                      })
                  "
                  @item-resolved="setProduct"
                  @next-page-resolved="
                    (data) => setProduct([...products, ...data])
                  "
                  :items="products"
                  v-model="ourProductFilter.productId"
                  @input="onChangeHandler"
                  clearable
                  infinite
                  name="select_on_block"
                >
                  <template #option="{ item }">
                    <v-list-item-title>
                      <p class="ma-0">{{ item.name }}</p>
                      <span class="v-messages">{{
                        item.attrs.join(" && ")
                      }}</span>
                    </v-list-item-title>
                  </template>
                </vue-select>
              </div>
            </template>
            <template #filter.state>
              <div class="pa-1">
                <custom-select
                  clearable
                  @input="onChangeHandler"
                  class="user_input no-margin"
                  v-model="ourProductFilter.forQRStatus"
                  :items="[
                    { name: $t('printedQr'), id: true },
                    { name: $t('notPrintedQr'), id: false },
                  ]"
                ></custom-select>
              </div>
            </template>
            <template #expandBtn="{ item, openHandler }">
              <triangle-btn
                :loading="item.loading"
                :active="item.show"
                @click="openHandler(item)"
              ></triangle-btn>
            </template>
            <template #item.state><span></span></template>
            <template #item.count="{ item }">{{
              item.count | numberParse
            }}</template>
            <template #item.guessReceiveDate="{ item }">{{
              item.itemGuessReceiveDate | dateParse
            }}</template>
            <template #item.receiverDate="{ item }">{{
              item.contractItemAcceptedDate | dateParse
            }}</template>
            <template #child.guessReceiveDate="{ child }">
              <span v-if="child.lot && child.date">
                {{ child.date.replace(/\./g, "/") }}
              </span>
            </template>
            <template #item.unitTypeName="{ item }">{{
              item[`unit_type_name_${$i18n.locale}`]
            }}</template>

            <template
              #child.action="{
                item,
                /**
                 * @type Object
                 * @property partitionId {string}
                 * @property accountingCode {string}
                 */
                child,
              }"
            >
              <div class="d-flex">
                <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="
                        $refs.accountCodeLotDialogRef.open({
                          partitionId: child.partitionId,
                          accountingCode: child.accountingCode,
                        })
                      "
                      v-on="on"
                      class="new_style"
                    >
                      <vue-icon icon="newPencilIcon"></vue-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("productCode") }}</span>
                </v-tooltip>
                <v-tooltip
                  v-if="child.lot"
                  :loading="child.loading"
                  nudge-top="35"
                  nudge-right="10"
                  color="#fff"
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                    <v-btn
                      :loading="child.loading"
                      @click="printQrLot(item, child)"
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                    >
                      <vue-icon icon="newPrintIcon"></vue-icon>
                    </v-btn>
                  </template>
                  <span>{{ $tc("printQrCode", 1) }}</span>
                </v-tooltip>
                <v-tooltip
                  v-if="child.lot && $store.getters.isUserAdmin"
                  nudge-top="35"
                  nudge-right="10"
                  color="#fff"
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="onDeleteLot(child.id)"
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                    >
                      <vue-icon icon="newTrashIcon"></vue-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("delete") }}</span>
                </v-tooltip>
              </div>
            </template>
            <template #child.count="{ child }">
              <template v-if="child.lot">
                <div style="line-height: 20px">
                  <p class="ma-0">
                    {{ $t("weight") }}: {{ child.count | numberParse }}
                  </p>
                  <p class="ma-0">
                    {{ $t("countQr") }}: {{ child.packageCount }}
                  </p>
                </div>
              </template>
              <span v-else>{{ child.count | numberParse }}</span>
            </template>
            <template #child.state="{ item, child }">
              <span
                v-if="trueSet(child.qrPrinted)"
                class="font-weight-bold no-wrap-text"
                style="color: rgb(239, 189, 23)"
                >{{ $t("printedQr") }}</span
              >
              <span
                class="font-weight-bold no-wrap-text"
                v-else
                style="color: #ee6565"
                >{{ $t("notPrintedQr") }}</span
              >
            </template>
            <template #child.contractNumber="{ child }">
              <span v-if="child.lot && child.name">
                Лот №: {{ child.name }}
              </span>
            </template>
          </table-with-filter>
        </div>
        <vue-pagination
          @update:limit="
            (limit) => {
              configuration.pagination.limit = limit;
              configuration.pagination.page = 1;
              changePage();
            }
          "
          v-model="configuration.pagination.page"
          :length="lastPage"
          @input="changePage"
          go-to
          :limit="configuration.pagination.limit"
        />
        <AccountCodeLotDialog
          @UPDATED="getContractItemsByFilter"
          ref="accountCodeLotDialogRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TriangleBtn from "@/components/table-with-children/triangleBtn";
import { debounce, makerPagination, trueSet } from "@/utils/pureFunctions";
import { QrService } from "@/utils/QrService";
import { LotTemplate } from "@/utils/qr-template/LotTemplate";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import AccountCodeLotDialog from "@/components/omtk/AccountCodeLotDialog";

export default {
  name: "PrintProduct",
  data() {
    return {
      isShowFilter: false,
      ourProductFilter: {
        /**
         * @type Object
         * @property forQRStatus
         */
        contractId: null,
        productId: null,
      },
      lastPage: 0,
      configuration: {
        pagination: {
          page: 1,
          limit: 10,
        },
        options: {
          sortBy: "id",
          sortDesc: true,
        },
      },
      items: [],
      products: [],
      totalCount: 0,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("contractNumber"),
          value: "contractNumber",
          sortable: true,
        },
        { text: this.$t("numberPositionInContract"), value: "numb" },
        { text: this.$t("typeProduct"), value: "productTypeName" },
        { text: this.$t("productGroup"), value: "productGroup" },
        { text: this.$t("product"), value: "productName" },
        { text: this.$t("productCode"), value: "accountingCode" },
        { text: this.$t("count"), value: "count" },
        { text: this.$t("unit"), value: "unitTypeName" },
        { text: this.$t("supplier"), value: "supplierName" },
        { text: this.$t("guessReceiveDate"), value: "guessReceiveDate" },
        { text: this.$t("receiverDate"), value: "receiverDate" },
        { text: this.$t("acceptUser"), value: "initiator" },
        { text: this.$t("state"), value: "state" },
        { text: this.$t("action"), value: "action" },
      ];
    },
    trueSet: () => trueSet,
  },
  methods: {
    setProduct(products) {
      this.products = products;
    },
    async onDeleteLot(id) {
      if (confirm(this.$t("wantDeleteHint").toString())) {
        this.showLoading();
        try {
          await this.$http.delete(`lot/delete?id=${id}`);
          await this.getContractItems();
          this.setSuccess({ text: this.$t("successfullyDeleted") });
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.clearLoading();
        }
      }
    },
    onChangeHandler: debounce(function () {
      this.getContractItemsByFilter();
    }, 300),
    clearFilter() {
      this.ourProductFilter = {
        contractId: null,
        productId: null,
      };
      this.onChangeHandler();
    },
    async changePage(page) {
      const { query: initialQuery } = this.$route;
      const { page: queryPage } = initialQuery;
      if (page.toString() !== queryPage) {
        this.showLoading();
        await this.$router.push({
          query: { ...initialQuery, page: page.toString() },
        });
        await this.getContractItems();
        this.clearLoading();
      }
    },
    async printQrLot({ contractNumber, productName }, child) {
      try {
        if (child.qrPrinted === "false") {
          child.qrPrinted = "true";
        }
        child.loading = true;
        const {
          data: { data: productItems },
        } = await this.$http.get(`lot/print?id=${child.id}`);
        const qrService = new QrService();
        for (let i = 0; i < productItems.length; i++) {
          const qrTemplate = new LotTemplate();
          qrTemplate.addText(`Id: ${productItems[i].qrCode}`);
          if (child.name) {
            qrTemplate.addText(`${child.name}`);
          }
          qrTemplate.addText(`№: ${contractNumber}`);
          if (productItems[i].state === "PRODUCT_PRODUCED")
            qrTemplate.addText("***");
          await qrTemplate.addQr(`{id: ${productItems[i].qrCode}}`, "#000000");
          qrService.add(qrTemplate.data);
        }
        // qrService.save(productName + '_qr')
        qrService.show(productName + "_qr");
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        child.loading = false;
      }
    },
    async getContractItemsByFilter() {
      if (this.ready) {
        this.showLoading();
        const { page } = this.configuration.pagination;
        if (page !== 1) {
          this.configuration.pagination.page = 1;
          await this.$router.push({ query: { page: `1` } });
        }
        await this.getContractItems();
        this.clearLoading();
      }
    },
    async getContractItemsBySort() {
      this.showLoading();
      const { query: initialQuery } = this.$route;
      const query = {
        ...initialQuery,
        ...this.configuration.pagination,
        ...this.configuration.options,
      };
      try {
        await this.$router.push({ query });
      } catch (e) {
        this.setResponseError({ error: e });
      }
      await this.getContractItems();
      this.clearLoading();
    },
    async getContractItems() {
      const { page, limit } = this.configuration.pagination;
      let params = {
        ...this.ourProductFilter,
        ...this.configuration.options,
        page: page - 1,
        limit: 10,
        forPrintQrCode: true,
      };
      try {
        const {
          data: { data, total },
        } = await this.$http.get("contract/list-item", {
          params,
        });
        this.items = data.map((contractItem) => {
          contractItem.show = true;
          contractItem.loading = false;
          if (
            contractItem.items &&
            contractItem.items.length &&
            contractItem.items[0].items
          ) {
            contractItem.items = contractItem.items.reduce(
              (initial, contractItemPart) => {
                if (contractItemPart.items) {
                  contractItemPart.items.forEach((item) => {
                    item.partitionId = contractItemPart.id;
                    item.lot = true;
                    item.loading = false;
                    item.date = contractItemPart.date;
                    initial.push(item);
                  });
                }
                return initial;
              },
              []
            );
          }
          return contractItem;
        });
        this.totalCount = total;
        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
  async created() {
    this.showLoading();
    try {
      const { page, sortBy, sortDesc } = this.$route.query;
      if (page) this.configuration.pagination.page = +page;
      if (sortBy) this.configuration.options.sortBy = sortBy;
      if (typeof sortDesc !== "undefined")
        this.configuration.options.sortDesc = trueSet(sortDesc);
      await this.getContractItems();
      const { data: products } = await this.$store.dispatch("getProducts");
      this.products = products;
      this.ready = true;
    } catch (e) {
      this.setResponseError({ error: e });
    } finally {
      this.clearLoading();
    }
  },

  components: {
    AccountCodeLotDialog,
    VuePagination,
    VueSelect,
    TableWithFilter,
    TriangleBtn,
  },
};
</script>
